import { createSelector } from 'reselect';
import { constants as tunnelsConstants } from '@saucelabs/sl-module-tunnels';

import * as utils from './utils';

const configuratorSelector = createSelector([
  (store) => store.apps.manual,
  (store) => store.userRdc,
  (store) => store.user,
  (store) => store.userTunnels,
],
(manual, userRdc, user, userTunnels) => ({
  appItems: manual.apps.get('items').toArray(),
  browsers: manual.metadata.get('browsers'),
  lastConfigApp: (defaultConfig) => {
    const recentAppConfigs = utils.getAppTestingConfigs(manual.metadata.get('recent_configs').toJS());
    return (recentAppConfigs.length && recentAppConfigs[0]) || defaultConfig;
  },
  lastConfigWeb: (defaultConfig) => {
    const recentWebConfigs = utils.getWebTestingConfigs(manual.metadata.get('recent_configs').toJS());
    return (recentWebConfigs.length && recentWebConfigs[0]) || defaultConfig;
  },
  recentConfigsWeb: utils.getWebTestingConfigs(manual.metadata.get('recent_configs').toJS()),
  savedConfigsWeb: utils.getWebTestingConfigs(manual.metadata.get('saved_configs').toJS()),
  recentConfigsApp: utils.getAppTestingConfigs(manual.metadata.get('recent_configs').toJS())
    .filter((app) => !app.mobileAppConfiguration.defaultApp),
  savedConfigsApp: utils.getAppTestingConfigs(manual.metadata.get('saved_configs').toJS()),
  sauceConnectPublicRdcEnabled: userRdc.get('sauceConnectForPublicCloudEnabled'),
  tunnels: userTunnels.getIn(
    ['tunnels', user.get('username')],
    tunnelsConstants.NO_TUNNELS_USER_FALLBACK,
  ).reduce((total, values) => [...total, ...values], []),
  uploadingItems: manual.apps.get('itemsUploading').toArray().reverse(),
  userRdcId: userRdc.get('id'),
}));

const mobileSessionSelector = createSelector([
  (store) => store.apps.manual.biometricsAuthentication,
  (store) => store.apps.manual.drawer,
  (store) => store.apps.manual.log,
  (store) => store.apps.manual.session,
  (store) => store.apps.manual.vitals,
  (store) => store.experiments,
  (store) => store.toolbar,
],
(biometricsAuthentication, drawer, log, session, vitals, experiments, toolbar) => ({
  biometricsAuthIsLoading: biometricsAuthentication.get('isLoading'),
  drawerHeight: drawer.get('height'),
  drawerOpen: drawer.get('open'),
  drawerWidth: drawer.get('width'),
  isInDeviceVitalsExperiment: experiments.get('web-ui-live-testing-device-vitals') === 'web-ui-live-testing-device-vitals',
  logActive: log.get('active'),
  session,
  toolbar,
  vitalsActive: vitals.get('active'),
}));

const vitalsSelector = createSelector([
  (store) => store.apps.manual.vitals,
],
(vitals) => ({
  active: vitals.get('active'),
  chartUpdateInterval: vitals.get('chartUpdateInterval'),
  fullWidthLayout: vitals.get('fullWidthLayout'),
  graphHeight: vitals.get('graphHeight'),
  visibleChartsData: vitals.get('visibleChartsData'),
}));

export default configuratorSelector;
export {
  configuratorSelector,
  mobileSessionSelector,
  vitalsSelector,
};
